import { useEffect, useState } from "react";
import MobileProductDetail from "./MobileProductDetail";
import DesktopProductDetail from "./DesktopProductDetail";


const ProductDetailPage = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <MobileProductDetail {...props} /> : <DesktopProductDetail {...props} />;
};

export default ProductDetailPage;